import { Link } from "react-router-dom";
import { TextLink } from "../components/kit/TextLink";
import { BrandMark } from "../components/brand/BrandMark";
import { newUi } from "../lib/featureFlags";
import { FRONT_DOOR_PATH } from "../lib/sessionExpiry";
import { DONE_BACKUPS, DONE_HOME, DONE_LEDE, DONE_TITLE } from "../lib/deleteAccount";

/**
 * The page a deleted account lands on (#1032, D204.2): public, outside the
 * app shell like the sign-in pages (`SignInLinkCallbackNew.jsx`), because the
 * session is already gone. It says what happened, so there is no toast
 * (D109). It reads nothing from the session and no navigation state, so a
 * direct visit shows the same page and reveals nothing.
 */
export default function AccountDeletedPage() {
  // One page for both looks (App.js, #1032). The new look takes the shared column (#1429); the old look keeps the
  // inline 480 at every width, byte for byte (D217). The gate is the screen's own flag, as the delete-account step's.
  const column = newUi("settings");
  return (
    <div style={{ minHeight: "100vh", background: "var(--nw-page)" }}>
      <span data-testid="account-deleted-new-screen" className="sr-only" style={{ color: "var(--nw-ink)" }} aria-hidden="true" />
      <div
        data-testid="account-deleted-page"
        className={column ? "nw-column" : undefined}
        style={{
          ...(column ? {} : { maxWidth: 480, margin: "0 auto" }),
          display: "flex",
          flexDirection: "column",
          gap: "var(--nw-space-stack)",
          padding: "var(--nw-space-page)",
          color: "var(--nw-ink)",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <BrandMark size={24} />
          <span style={{ fontFamily: "'Manrope', sans-serif", fontWeight: 800, fontSize: 16, color: "var(--nw-navy)" }}>
            Compass
          </span>
        </div>
        <h1 className="nw-title-lg" style={{ margin: 0 }}>
          {DONE_TITLE}
        </h1>
        <p style={{ margin: 0, fontSize: 14, lineHeight: 1.5, color: "var(--nw-ink-lede)" }}>{DONE_LEDE}</p>
        <p style={{ margin: 0, fontSize: 12, lineHeight: 1.5, color: "var(--nw-ink-muted)" }}>{DONE_BACKUPS}</p>
        <TextLink
          as={Link}
          to={FRONT_DOOR_PATH}
          data-testid="account-deleted-home"
          style={{ color: "var(--nw-navy)", fontWeight: 600, fontSize: 14, textDecoration: "underline" }}
        >
          {DONE_HOME}
        </TextLink>
      </div>
    </div>
  );
}
